// -----------------------------------------------------------------
// CustomCrypto: with Forge (to support 3DES) instead of Node.Crypto
// -----------------------------------------------------------------
import PKIUtils from './PKIUtils'
// -----------------------------------------------------------------
// Forge (to support 3DES)
// -----------------------------------------------------------------
const forge = require('node-forge')
// -----------------------------------------------------------------
// CustomCrypto as module
// -----------------------------------------------------------------
export default class CustomCrypto {
  // ---------------------------------------------------------------
  // createHash(): Return Cipher Object
  // ---------------------------------------------------------------
  static async createHash (hashAlgorithm, data) {
    // console.log('CustomCrypto.createHash():ENTER')
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.createHash():LEAVE')
  }
  // ---------------------------------------------------------------
  // createHmac():
  // ---------------------------------------------------------------
  static async createHmac (hashAlgorithm, key) {
    // console.log('CustomCrypto.createHmac():ENTER')
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.createHmac():LEAVE')
  }
  // ---------------------------------------------------------------
  // pbkdf2Sync():
  // ---------------------------------------------------------------
  static async pbkdf2Sync (hashAlgorithm) {
    // console.log('CustomCrypto.pbkdf2Sync():ENTER')
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.pbkdf2Sync():LEAVE')
  }
  // ---------------------------------------------------------------
  // createCipheriv():
  // ---------------------------------------------------------------
  // https://nodejs.org/api/crypto.html#crypto_crypto_createcipheriv_algorithm_key_iv_options
  // ---------------------------------------------------------------
  static async createCipheriv (algorithm, key, iv) {
    // console.log('CustomCrypto.createCipheriv():ENTER')
    // console.log('CustomCrypto.createCipheriv():algorithm=' + algorithm)
    // console.log('CustomCrypto.createCipheriv():key=' + PKIUtils.ary2hex(key))
    // console.log('CustomCrypto.createCipheriv():iv=' + PKIUtils.ary2hex(iv))
    // TODO: Need to implement for compatibility with Node Crypto
    let cipher = null
    if (algorithm === 'DES-EDE3-CBC') {
      let vkey = forge.util.createBuffer(key)
      let viv = forge.util.createBuffer(iv)
      cipher = forge.cipher.createCipher('3DES-CBC', vkey)
      cipher.start({ iv: viv })
    }
    // console.log('CustomCrypto.createCipheriv():LEAVE')
    return cipher
  }
  // ---------------------------------------------------------------
  // createDecipheriv():
  // ---------------------------------------------------------------
  static async createDecipheriv (algorithm, key, iv) {
    // console.log('CustomCrypto.createDecipheriv():ENTER')
    // console.log('CustomCrypto.createDecipheriv():algorithm=' + algorithm)
    // console.log('CustomCrypto.createDecipheriv():key=' + key)
    // console.log('CustomCrypto.createDecipheriv():iv=' + iv)
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.createDecipheriv():LEAVE')
  }
  // ---------------------------------------------------------------
  // createCipher():
  // ---------------------------------------------------------------
  static async createCipher (algorithm, key) {
    // console.log('CustomCrypto.createCipher():ENTER')
    // console.log('CustomCrypto.createCipher():algorithm=' + algorithm)
    // console.log('CustomCrypto.createCipher():key=' + key)
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.createCipher():LEAVE')
  }
  // ---------------------------------------------------------------
  // createDecipher():
  // ---------------------------------------------------------------
  static async createDecipher (algorithm, key) {
    // console.log('CustomCrypto.createDecipher():ENTER')
    // console.log('CustomCrypto.createDecipher():algorithm=' + algorithm)
    // console.log('CustomCrypto.createDecipher():key=' + key)
    // TODO: Need to implement for compatibility with Node Crypto
    // console.log('CustomCrypto.createDecipher():LEAVE')
  }

  // ===============================================================
  // The fowlloing are original methods
  // ===============================================================

  // ---------------------------------------------------------------
  // encrypt(): Original Method
  // ---------------------------------------------------------------
  static async encrypt (algorithm, key, iv, input) {
    // console.log('CustomCrypto.encrypt():ENTER')
    // console.log('CustomCrypto.encrypt():algorithm=' + algorithm)
    // console.log('CustomCrypto.encrypt():key=' + PKIUtils.ary2hex(key))
    // console.log('CustomCrypto.encrypt():iv=' + PKIUtils.ary2hex(iv))
    // console.log('CustomCrypto.encrypt():input=' + PKIUtils.ary2hex(input))
    let result = null
    if (algorithm === 'DES-EDE3-CBC') {
      // Convert ArrayBuffer to BufferStringBuffer (for Forge)
      let vkey = forge.util.createBuffer(key)
      let viv = forge.util.createBuffer(iv)
      // console.log(vkey)
      // console.log(viv)
      // Generate Cipher with Forge
      let cipher = forge.cipher.createCipher('3DES-CBC', vkey)
      // Encrypt input data
      cipher.start({ iv: viv })
      cipher.update(forge.util.createBuffer(input, 'binary'))
      cipher.finish()
      // Convert Output to HexString
      let hex = cipher.output.toHex()
      // console.log('CustomCrypto.encrypt():output=' + hex)
      // Convert HexString to Uint8Array
      result = PKIUtils.hex2ary(hex).buffer
      // console.log('CustomCrypto.encrypt():output=' + PKIUtils.ary2hex(result))
    }
    // console.log('CustomCrypto.encrypt():LEAVE')
    return result
  }
  // ---------------------------------------------------------------
  // calcHmac(): Original Method
  // ---------------------------------------------------------------
  static async calcHmac (algorithm, key, input) {
    // console.log('CustomCrypto.calcHmac():ENTER')
    // console.log('CustomCrypto.calcHmac():algorithm=' + algorithm)
    // console.log('CustomCrypto.calcHmac():key=' + PKIUtils.ary2hex(key))
    // console.log('CustomCrypto.calcHmac():input=' + PKIUtils.ary2hex(input))
    let result = null
    let md = null
    // -------------------------------------------------------------
    // 1) Select Algorithm for Message Digest
    // -------------------------------------------------------------
    switch (algorithm) {
      case 'SHA-1': md = forge.md.sha1.create(); break
      case 'SHA-256': md = forge.md.sha256.create(); break
      case 'SHA-384': md = forge.md.sha384.create(); break
      case 'SHA-512': md = forge.md.sha512.create(); break
      default: break
    }
    // -------------------------------------------------------------
    // 2) Calc HMAC with MD
    // -------------------------------------------------------------
    if (md) {
      // Convert ArrayBuffer to BufferStringBuffer (for Forge)
      let vkey = forge.util.createBuffer(key)
      let data = forge.util.createBuffer(input, 'binary')
      // Generate HMAC with Forge
      var hmac = forge.hmac.create()
      // Calc HMAC
      hmac.start(md, vkey)
      hmac.update(data.getBytes())
      var macValue = hmac.getMac()
      // Convert to HexString
      let hex = macValue.toHex()
      // console.log('CustomCrypto.calcHmac():output=' + hex)
      // Convert HexString to Uint8Array
      result = PKIUtils.hex2ary(hex).buffer
    }
    // console.log('CustomCrypto.calcHmac():LEAVE')
    return result
  }
}
